__turbopack_context__.v({
  "ChartLoading": "D2g3NG_ChartLoading",
  "ChartLoadingText": "D2g3NG_ChartLoadingText",
  "CheckboxItem": "D2g3NG_CheckboxItem",
  "CheckboxLabel": "D2g3NG_CheckboxLabel",
  "CheckboxList": "D2g3NG_CheckboxList",
  "ClearAllFilters": "D2g3NG_ClearAllFilters",
  "ClearButton": "D2g3NG_ClearButton",
  "ClearIcon": "D2g3NG_ClearIcon",
  "Content": "D2g3NG_Content",
  "Country": "D2g3NG_Country",
  "CountryLabel": "D2g3NG_CountryLabel",
  "Field": "D2g3NG_Field",
  "FieldLabel": "D2g3NG_FieldLabel",
  "FieldValue": "D2g3NG_FieldValue",
  "FieldValueStrong": "D2g3NG_FieldValueStrong",
  "FilterButton": "D2g3NG_FilterButton",
  "FilterButtons": "D2g3NG_FilterButtons",
  "FilterIcon": "D2g3NG_FilterIcon",
  "FilterRow": "D2g3NG_FilterRow",
  "FilterSeparator": "D2g3NG_FilterSeparator",
  "FourColumns": "D2g3NG_FourColumns",
  "GridWrapper": "D2g3NG_GridWrapper",
  "IndividualSkeleton": "D2g3NG_IndividualSkeleton",
  "Individuals": "D2g3NG_Individuals",
  "LastUpdated": "D2g3NG_LastUpdated",
  "NaceCode": "D2g3NG_NaceCode",
  "Network": "D2g3NG_Network",
  "Panel": "D2g3NG_Panel",
  "People": "D2g3NG_People",
  "PeopleScroll": "D2g3NG_PeopleScroll",
  "Person": "D2g3NG_Person",
  "PersonCompany": "D2g3NG_PersonCompany",
  "PersonName": "D2g3NG_PersonName",
  "PersonRole": "D2g3NG_PersonRole",
  "PopoverContent": "D2g3NG_PopoverContent",
  "Root": "D2g3NG_Root",
  "Root--Network": "D2g3NG_Root--Network",
  "SearchButton": "D2g3NG_SearchButton",
  "SearchField": "D2g3NG_SearchField",
  "SearchIcon": "D2g3NG_SearchIcon",
  "SearchInput": "D2g3NG_SearchInput",
  "SearchWrapper": "D2g3NG_SearchWrapper",
  "Tab": "D2g3NG_Tab",
  "TabRow": "D2g3NG_TabRow",
  "Tabs": "D2g3NG_Tabs",
  "ThreeColumns": "D2g3NG_ThreeColumns",
  "Title": "D2g3NG_Title",
  "TwoColumns": "D2g3NG_TwoColumns",
  "Website": "D2g3NG_Website",
  "WebsiteIcon": "D2g3NG_WebsiteIcon",
  "Websites": "D2g3NG_Websites",
  "ZeroStateWrapper": "D2g3NG_ZeroStateWrapper",
  "skeleton-loading": "D2g3NG_skeleton-loading",
});
